import type { FC, ReactNode } from 'react';
import { Info } from 'lucide-react';

interface AdviceNoticeProps {
  /** Extra lines under the standing disclaimer, e.g. the out-of-date warning. */
  children?: ReactNode;
  /** The pre-run wording also has to say when running is allowed at all. */
  variant?: 'intro' | 'results';
}

/** The standing "this is advice" disclaimer that sits in every panel footer. */
export const AdviceNotice: FC<AdviceNoticeProps> = ({ children, variant = 'results' }) => (
  <div
    className="flex gap-2.5 rounded-lg bg-gray-50 px-3.5 py-3 text-xs leading-[18px] text-gray-600"
    data-testid="pbqa-advice-notice"
  >
    <Info className="mt-px size-4 shrink-0 text-gray-400" aria-hidden />
    <div className="flex flex-col gap-2.5">
      <p>
        <span className="font-semibold text-gray-900">Advice, not validation.</span> Guidance does not approve or bind
        this contract.{' '}
        {variant === 'intro'
          ? 'Only run guidance where the client permits the use of AI tools on their contract. '
          : ''}
        Your review and judgement are always required.
      </p>
      {children}
    </div>
  </div>
);
